import { useEffect, useRef } from "react";
import { Tooltip, theme } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { useEntityContext } from "../useEntityContext";

export const BottomNav = () => {
  const { token } = theme.useToken();
  const { setUuid, nextUuid, previousUuid, entityList } = useEntityContext();
  const containerRef = useRef<HTMLDivElement>(null);
  const keyStyle: React.CSSProperties = {
    border: `1px solid ${token.colorBgBase}`,
    borderRadius: token.borderRadiusXS,
    padding: 2,
  };

  const uuidSetter = useRef({ setUuid });
  uuidSetter.current = { setUuid };
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "ArrowUp" && previousUuid) {
        uuidSetter.current.setUuid(previousUuid);
      } else if (event.key === "ArrowDown" && nextUuid) {
        uuidSetter.current.setUuid(nextUuid);
      }
    };

    window.addEventListener("keyup", handleKeyPress);

    return () => {
      window.removeEventListener("keyup", handleKeyPress);
    };
  }, [previousUuid, nextUuid]);

  if (!entityList || entityList.length === 0) return null;
  return (
    <div
      style={{
        backgroundColor: token.colorBgContainer,
        lineHeight: "20px",
        width: "100%",
        borderBottomLeftRadius: token.borderRadiusLG,
      }}
      ref={containerRef}
      tabIndex={0}
    >
      <div
        style={{
          backgroundColor: token.colorBgLayout,
          color: token.colorTextTertiary,
          padding: 5,
          paddingLeft: 16,
          fontSize: 12,
          borderBottomLeftRadius: token.borderRadiusLG,
        }}
      >
        {entityList && entityList.length > 0 && (
          <>
            Move through list with{" "}
            {previousUuid && (
              <Tooltip title={previousUuid}>
                <ArrowUpOutlined style={keyStyle} />
              </Tooltip>
            )}{" "}
            {nextUuid && (
              <Tooltip title={nextUuid}>
                <ArrowDownOutlined style={keyStyle} />
              </Tooltip>
            )}{" "}
            keys
          </>
        )}
      </div>
    </div>
  );
};
